/* src/app/rate-planning/rate-planning-presenter/rate-planning-presenter.component.scss */
.page-overlay {
  top: 52px;
  left: 0px;
  position: fixed;
  opacity: 0.5;
  z-index: 9998;
  background-color: #000;
}
.page-overlay-content {
  opacity: 1;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 2.5rem;
  background-color: transparent;
  box-shadow: 5px 8px 5px black;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.processing-overlay-content {
  opacity: 1;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: yellow;
  background-color: transparent;
  box-shadow: 5px 8px 5px black;
  z-index: 9999;
  font-size: 1.5rem !important;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.logo-wrapper {
  position: relative;
  width: 150px;
  height: 150px;
}
.spinning-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top: 6px solid #1E3C72;
  border-right: 6px solid #1E3C72;
  border-bottom: 6px solid #1E3C72;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  will-change: transform;
  z-index: 2;
}
.loading-container:not([hidden]) .spinning-border {
  animation: spin 2s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .spinning-border {
    animation: none !important;
  }
}
.logo-container {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  width: 150px;
  height: 150px;
  z-index: 1;
}
.efact-logo {
  max-width: 120px;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: contain;
  opacity: 1 !important;
  filter: contrast(1.2) brightness(1.1);
  background-color: transparent;
}
.loading-text {
  font-size: 1.25rem;
  color: white;
  text-align: center;
  margin-top: 10px;
  font-weight: 300;
  letter-spacing: 1px;
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=rate-planning-presenter.component.css.map */
